let slides = [
  {
    quote: "testimonial.test1.quote",
    author: {
      name: "testimonial.test1.name",
      description: "",
      img: "https://scontent.fotp3-3.fna.fbcdn.net/v/t1.15752-9/31453881_1704515236263476_4618382980543414272_n.png?_nc_cat=108&oh=0b04a2df76ac8e9052a1c4355c17bc13&oe=5C54CA38"
    }
  },
  {
    quote: "testimonial.test2.quote",
    author: {
      name: "testimonial.test2.name",
      description: "",
      img: "https://scontent.fotp3-3.fna.fbcdn.net/v/t1.15752-9/31577812_1704522422929424_5437934840236212224_n.png?_nc_cat=104&oh=533689544f598ed290fd4904776f8b96&oe=5C17B796"
    }
  },
  {
    quote: "testimonial.test3.quote",
    author: {
      name: "testimonial.test3.name",
      description: "",
      img: "https://scontent.fotp3-3.fna.fbcdn.net/v/t1.15752-9/31689078_1704526806262319_4393284839776714752_n.png?_nc_cat=104&oh=85c4e085c15270edc5708201afe782c7&oe=5C1F4C10"
    }
  }
  
]

export default slides;